"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowFactoryFromJS = exports.WindowFactory = void 0;
const __1 = require("..");
const immutable_1 = require("immutable");
exports.WindowFactory = (0, immutable_1.Record)({
    items: (0, immutable_1.Map)(),
    clientWidth: null,
    clientHeight: null,
    centerWidth: null,
    centerHeight: null,
    bottomStackPanelPinned: null,
    leftStackPanelPinned: null,
    rightStackPanelPinned: null,
    topStackPanelPinned: null
});
const WindowFactoryFromJS = function (data) {
    const items = Object.keys(data.items).reduce(function (previous, current) {
        previous[current] = (0, __1.WindowItemFactoryFromJS)(data.items[current]);
        return previous;
    }, {});
    return (0, exports.WindowFactory)({
        items: (0, immutable_1.Map)(items),
        clientHeight: data.clientHeight,
        clientWidth: data.clientWidth,
        centerWidth: data.centerWidth,
        centerHeight: data.centerHeight,
        bottomStackPanelPinned: data.bottomStackPanelPinned,
        leftStackPanelPinned: data.leftStackPanelPinned,
        rightStackPanelPinned: data.rightStackPanelPinned,
        topStackPanelPinned: data.topStackPanelPinned
    });
};
exports.WindowFactoryFromJS = WindowFactoryFromJS;
//# sourceMappingURL=IWindow.js.map